import React from "react";

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
  Image
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import accessoriesService from "../../../services/accessories.service";
import AccessoriesColorsPage from "../accessories-colors";
import PaletteIcon from "@material-ui/icons/Palette";
import AccessoryGalleryForm from "./accessoryGallery/accessoryGalleryForm";

const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

const headerCells = [
  {
    field: "name",
    title: "نام",
    mainField: true,
  },
  {
    field: "brandId",
    title: "برند",
    disableSort: true,
    renderer: (val, _, extra) =>
      extra?.brands?.find((b) => b.id === val)?.name || "",
  },
  {
    field: "categoryId",
    title: "نوع",
    disableSort: true,
    renderer: (val, _, extra) =>
      extra?.categories?.find((b) => b.id === val)?.name || "",
  },
  {
    field: "colors",
    title: "رنگ‌ها",
    disableSort: true,
    renderer: (val, row, extra) => val.map((c) => c.name).join(", "),
  },
  {
    field: "isActive",
    title: "وضعیت",
    // disableSort: true,
    renderer: (val) => (val ? "فعال" : "غیر فعال"),
  },
  {
    field: "createDate",
    title: "تاریخ ایجاد",
    date: true,
  },
];

export default function AccessoriesPage() {
  const deleteItem = (item) => {
    return accessoriesService.deleteAccessory(item.id);
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        backend={accessoriesService.getAccessoriesUrl}
        rowActions={[
          {
            icon: <PaletteIcon />,
            modalProps: { fullScreen: true },
            refreshOnClose: true,
            modalContent: (props) => <AccessoriesColorsPage {...props.data} />,
          },
          {
            modalProps: { maxWidth: "md" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <Image />,
            modalContent: (props) => <AccessoryGalleryForm {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "md" },
            icon: <AddIcon />,
            tooltip: "ایجاد اکسسوری",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title="اکسسوری‌ها"
        orderBy="createDate"
      />
    </div>
  );
}
